<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button *ngIf="!visibilitySpinner" [disabled]="formInvalid" type="button" class="btn btn-outline-success" (click)="onSave()" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
        <div *ngIf="ambitoPeriodo && esPeriodoFinalizado" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo finalizado</label>
        </div>
        <ng-container *ngIf="ambitoPeriodo && !esPeriodoFinalizado">
            <div *ngIf="esVigenteConSolicitudes" class="nota-info">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo con plazos y solicitudes vigentes. Ciertos campos aparecerán deshabilitados.</label>
            </div>
        </ng-container>
    </form>
</nav>

<app-ambito-edit [comunidades]="comunidades" [provincias]="provincias" [ambitoPeriodo]="ambitoPeriodo" [formGroup]="form" 
                 [esPeriodoFinalizado]="esPeriodoFinalizado" [esVigenteConSolicitudes]="esVigenteConSolicitudes"
                 (selectComunidadEmitter)="onSelectComunidad($event)"
                 (selectAmbitoEmitter)="onSelectAmbito()" (addComunidadEmitter)="onAddComunidad($event)" (deleteComunidadEmitter)="onDeleteComunidad($event)"
                 (addProvinciaEmitter)="onAddProvincia($event)" (deleteProvinciaEmitter)="onDeleteProvincia($event)"></app-ambito-edit>
